// angular
//     .module("HeroPRO")
// 	.controller("PaymentInstructionsModalController", paymentInstructionsModalController);

import _ from 'lodash';

/* @ngInject */
export default function paymentInstructionsModalController($scope, $state, raSpinnerService, $stateParams, FRInformationFactory, FRClosingFactory) {
    const vm = this;
    vm.displayForm = true;
    vm.paymentInstructions = {};
    vm.advancePayment = {};
    vm.contractor = {};
    vm.propertyOwner = {};
    vm.designee = {};
    vm.contractorDisbursementAmount = null;
    vm.propertyOwnerDisbursementAmount = null;
    vm.designeeDisbursementAmount = null;

    init();

    vm.addressPOCollapsed = function () {
        return vm.propertyOwnerDisbursementAmount <= 0;
    };

    vm.addressPOValid = function (form) {
        return form.paymentInstructionsPOName.$valid &&
   form.paymentInstructionsPOAddress.$valid &&
   form.paymentInstructionsPOCity.$valid &&
   form.paymentInstructionsPOState.$valid &&
   form.paymentInstructionsPOZip.$valid;
    };

    vm.addressPOUntouched = function (form) {
        return form.paymentInstructionsPOName.$untouched ||
   form.paymentInstructionsPOAddress.$untouched ||
   form.paymentInstructionsPOCity.$untouched ||
   form.paymentInstructionsPOState.$untouched ||
   form.paymentInstructionsPOZip.$untouched;
    };

    vm.addressDesigneeCollapsed = function () {
        return vm.designeeDisbursementAmount <= 0;
    };

    vm.addressDesigneeValid = function (form) {
        return form.paymentInstructionsDesigneeName.$valid &&
   form.paymentInstructionsDesigneeAddress.$valid &&
   form.paymentInstructionsDesigneeCity.$valid &&
   form.paymentInstructionsDesigneeState.$valid &&
   form.paymentInstructionsDesigneeZip.$valid;
    };

    vm.addressDesigneeUntouched = function (form) {
        return form.paymentInstructionsDesigneeName.$untouched &&
   form.paymentInstructionsDesigneeAddress.$untouched &&
   form.paymentInstructionsDesigneeCity.$untouched &&
   form.paymentInstructionsDesigneeState.$untouched &&
   form.paymentInstructionsDesigneeZip.$untouched;
    };

    vm.totalAmount = function () {
        return vm.contractorDisbursementAmount + vm.propertyOwnerDisbursementAmount + vm.designeeDisbursementAmount;
    };

    vm.isTotalExceeded = function () {
        return vm.totalAmount() > vm.paymentInstructions.InitialRequested;
    };

    vm.saveChanges = function (form) {
        if (vm.isTotalExceeded() === true || !form.$valid) {
            return;
        }

        // Now that the changes are being saved, set the application variables
        vm.contractor.DisbursementAmount = vm.contractorDisbursementAmount;
        vm.propertyOwner.DisbursementAmount = vm.propertyOwnerDisbursementAmount;
        vm.designee.DisbursementAmount = vm.designeeDisbursementAmount;

        let params = {};

        if (vm.paymentInstructions.LockDisbursements === true) {
            params = {
	            PaymentInstructions: {
	                FundingRequestId: $stateParams.appId,
	            },
	        };
        } else {
            params = {
	            PaymentInstructions: {
	                FundingRequestId: $stateParams.appId,
	                TotalApproved: vm.totalAmount(),
	                Disbursements: _.filter(vm.paymentInstructions.newDisbursements, disbursement => disbursement.DisbursementAmount > 0),
	            },
	        };
        }

        vm.displayForm = false;
    	raSpinnerService.show('paymentInstructionsModalSpinner');

        confirmPaymentInstructions(params);
    };

    vm.closeModal = function () {
        raSpinnerService.hide('paymentInstructionsModalSpinner');
        raSpinnerService._unregister('paymentInstructionsModalSpinner');
        $scope.$close();
    };

    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.paymentInstructions = FRClosingFactory.getPaymentInstructions();
            vm.advancePayment = vm.paymentInstructions.advancePayment;
            vm.contractor = vm.paymentInstructions.newDisbursements[0];
            vm.propertyOwner = vm.paymentInstructions.newDisbursements[1];
            vm.designee = vm.paymentInstructions.newDisbursements[2];
            // Copy values for use in the modal so that the application variables aren't modified
            vm.contractorDisbursementAmount = vm.contractor.DisbursementAmount;
            vm.propertyOwnerDisbursementAmount = vm.propertyOwner.DisbursementAmount;
            vm.designeeDisbursementAmount = vm.designee.DisbursementAmount;
        });
    }

    function confirmPaymentInstructions(params) {
        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.confirmPaymentInstructions(params).then((response) => {
            FRInformationFactory.setStateMachineData(response.data.Data.PipelineStageId, response.data.Data.FundingRequestPipelineStageId, response.data.Data.LoanStateId, response.data.Data.FundingRequestStateId, response.data.Data.CompletionCertificateStateId);
            FRClosingFactory.setPaymentInstructions(_.omit(response.data.Data, 'FundingRequestId', 'LoanStateId'));
            // Refresh the page so that the information for the newly generated CC is available on the page
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/paymentInstructions/paymentInstructionsModalController.js